import { ROLES } from "../../../utils/constants";

// The Directus field key and its choice values on the dynamic_tasks collection.
// If the backend field differs, correct these two constants — nothing else changes.
export const DEPARTMENT_FIELD = "department";
export const ALL_DEPARTMENTS = ["nfb", "psy", "management", "client_owner", "prescription"];

// Roles limited to a subset of departments. Any role NOT listed here is unrestricted.
const departmentsByRole: Record<string, Array<string>> = {
	[ROLES.neurofeedback_director]: ["nfb", "client_owner", "prescription"],
	[ROLES.technical_director]: ["psy", "management", "client_owner", "prescription"]
};

export const getAllowedDepartments = (roleId?: string) => {
	const restrictedDepartments = roleId ? departmentsByRole[roleId] : undefined;
	const allowedDepartments = restrictedDepartments ?? ALL_DEPARTMENTS;
	return allowedDepartments;
};

export const isDepartmentAllowed = (roleId: string | undefined, department: string | undefined) => {
	const allowedDepartments = getAllowedDepartments(roleId);
	const isAllowed = !department || allowedDepartments.includes(department);
	return isAllowed;
};
